<template>
<div class="chapter">
<div class="inner_page">
<p class="cover" style="text-align:center;"><img alt="cover" height="760" src="images/cover.jpg" style="height: 100%; width: auto" width="493"/><a id="pi"></a><a id="pii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?e5751dca